/**
 * https://docs.oracle.com/cd/B28359_01/server.111/b28318/datatype.htm#CNCPT012
 */
export const OracleTypes: string[] = [
  'BFILE',
  'BINARY_DOUBLE',
  'BINARY_FLOAT',
  'BLOB',
  'CHAR',
  'CLOB',
  'DATE',
  'DATETIME',
  'LONG RAW',
  'LONG',
  'NCHAR',
  'NCLOB',
  'NUMBER',
  'NVARCHAR2',
  'RAW',
  'TIMESTAMP WITH LOCAL TIME ZONE',
  'TIMESTAMP WITH TIME ZONE',
  'TIMESTAMP',
  'UriType',
  'VARCHAR',
  'VARCHAR2',
  'XMLType',
];
